export default "__VITE_ASSET__CNZ$jHps__"